import API from './api';
import LocalStorageService from './localStorage';

const localStorageService = LocalStorageService.getService();

export const getBrandingData = (id) => {
  return API.get(`pacheck-portal/branding/${id}`, {
    headers: { },
  });
};

export const getProcDiagCodes = (payload) => {
  if(payload.type === 'diagnosis' || payload.type === 'procedures') {
    return API.get(`pacheck-portal/codes/${payload.type}?keyword=${payload.query}`, {
      headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
    });
  } else {
    return API.get(`pacheck-portal/entities/${payload.orgId}/${payload.type}?keyword=${payload.query}`, {
      headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
    });
  }
  
};

export const getPACheckResults = (postData) => {
  postData.record_number = postData.record_number && postData.record_number.groupId ? postData.record_number.groupId : postData.record_number;
  return API.post(`pacheck-portal/lookup/${postData.id}`, postData, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};